/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResendApplication_requestSignature_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string };

export type ResendApplication_Mutation = { readonly __typename: 'Mutation', readonly requestSignature: ResendApplication_requestSignature_CreditApplication };


export type ResendApplicationVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type ResendApplication = ResendApplication_Mutation;


export const ResendApplicationDocument = gql`
    mutation ResendApplication($creditApplicationId: ID!) {
  requestSignature(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
  }
}
    `;
export type ResendApplicationMutationFn = Apollo.MutationFunction<ResendApplication, ResendApplicationVariables>;

/**
 * __useResendApplication__
 *
 * To run a mutation, you first call `useResendApplication` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendApplication` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendApplication, { data, loading, error }] = useResendApplication({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useResendApplication(baseOptions?: Apollo.MutationHookOptions<ResendApplication, ResendApplicationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendApplication, ResendApplicationVariables>(ResendApplicationDocument, options);
      }
export type ResendApplicationHookResult = ReturnType<typeof useResendApplication>;
export type ResendApplicationMutationResult = Apollo.MutationResult<ResendApplication>;
export type ResendApplicationMutationOptions = Apollo.BaseMutationOptions<ResendApplication, ResendApplicationVariables>;